import Timeline from '@components/components/Timeline/Timeline';
import React from 'react';

const CmsTimeline = ({
  headingLevel,
  footerType,
  isAnimated,
  items,
  containerDimension,
}) => (
  <Timeline
    containerDimension={containerDimension}
    footerType={footerType}
    headingLevel={headingLevel}
    isAnimated={isAnimated}
    items={items}
  />
);

export default CmsTimeline;
